// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".expandContainer___rr\\+B5{width:14px!important;height:14px!important}\n", "",{"version":3,"sources":["webpack://./src/components/Table/utils/index.css"],"names":[],"mappings":"AAAA,0BACI,oBAAA,CACA,qBAAA","sourcesContent":[".expandContainer {\n    width: 14px !important;\n    height: 14px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"expandContainer": "expandContainer___rr+B5"
};
export default ___CSS_LOADER_EXPORT___;
